import React from 'react';
import { Link } from 'react-router-dom';

export const HomeCard = ({ title, count, icon, link, onClick }) => {
  return (
    <div className="bg-white overflow-hidden shadow rounded-lg">
      <div className="p-5">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            {icon}
          </div>
          <div className="ml-5 w-0 flex-1">
            <dl>
              <dt className="text-sm font-medium text-gray-500 truncate">{title}</dt>
              <dd>
                <div className="text-lg font-medium text-gray-900">{count}</div>
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <div className="bg-gray-50 px-5 py-3">
        <div className="text-sm">
          {!!link && (
          <Link
            to={link}
            className="font-medium text-cyan-700 hover:text-cyan-900"
          >
            View all
          </Link>
          )}
          {!!onClick && (
          <button
            type="button"
            onClick={onClick}
            className="font-medium text-cyan-700 hover:text-cyan-900"
          >
            View all
          </button>
          )}
        </div>
      </div>
    </div>
  );
};
